import { TranslationKey } from 'state/intl/types';
import { Region } from 'utils/environment/types';

import { IsoCountryCode, CountryCode as PaymentISOs } from '../../generated/graphql-gateway';

export enum ISOs {
  USA = 'USA',
  CAN = 'CAN',
  US = 'USA',
  CA = 'CAN',
}

export const MAP_ISOs_TO_ISO_COUNTRY_CODE: Record<ISOs, IsoCountryCode> = {
  [ISOs.CA]: IsoCountryCode.CAN,
  [ISOs.US]: IsoCountryCode.USA,
};

export { ISOs as IsoCountryCode };

export enum RegionToISOs {
  US = ISOs.USA,
  CA = ISOs.CAN,
}

export enum ISOsToRegions {
  USA = Region.US,
  CAN = Region.CA,
}

export { PaymentISOs };

export enum Currencies {
  USD = 'USD',
  CAD = 'CAD',
}

export const getCountryAndCurrencyCodes = (
  billingCountry: ISOs
): { countryCode: PaymentISOs; currencyCode: Currencies } => {
  return (
    {
      [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD },
      [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD },
    }[billingCountry] || {
      countryCode: PaymentISOs.US,
      currencyCode: Currencies.USD,
    }
  );
};

export const postalCodeStringLocaleKey: Record<string, TranslationKey> = {
  [ISOs.USA]: 'zipCode',
  [ISOs.CAN]: 'postalCode',
};

export const postalCodeInputProperties = {
  [ISOs.USA]: { maxLength: 5, pattern: '[0-9]*' },
  [ISOs.CAN]: { maxLength: 7 },
};

export const regionStringLocaleKey: Record<string, TranslationKey> = {
  [ISOs.USA]: 'state',
  [ISOs.CAN]: 'province',
};

export const regionInputProperties = {
  [ISOs.USA]: { maxLength: 2 },
  [ISOs.CAN]: { maxLength: 2 },
};
